import { Routes, Route } from "react-router-dom";
import { PatientLandingPage } from "../landing-patient/PatientLandingPage";
import { ClinicLandingPage } from "../landing-clinic/ClinicLandingPage";
import { NotFoundPage } from "@/shared/ui/components/NotFoundPage";
import { FRONTEND_ROUTES } from "@fysaro/shared";
import { ContactPage } from "../ContactPage";
import { PrivacyPolicyPage } from "../PrivacyPolicyPage";
import { TermsAndConditionsPage } from "../TermsAndConditionsPage";
import { CookiePolicyPage } from "../CookiePolicyPage";
import { LegalNoticePage } from "../LegalNoticePage";
import { PublicClinicPage } from "../PublicClinicPage";
import PatientRecoveryPlanPage from "../recovery-plan/PatientRecoveryPlanPage";
import { CookieNotice } from "../components/CookieNotice";

export function PublicRoutes() {
  return (
    <>
      <Routes>
      <Route path="/" element={<ClinicLandingPage />} /> {/* Web de venta al fisio */}
      <Route path="info-patients" element={<PatientLandingPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="terms-and-conditions" element={<TermsAndConditionsPage />} />
      <Route path="cookie-policy" element={<CookiePolicyPage />} />
      <Route path="legal-notice" element={<LegalNoticePage />} />
      
      {/* 🚀 EL NUEVO PORTAL ACCESIBLE DESDE EL QR */}
      <Route path="p/:slug" element={<PublicClinicPage />} />
      <Route path="plan/:planId" element={<PatientRecoveryPlanPage />} />

      <Route
        path="*"
        element={
          <NotFoundPage
            backToPath={FRONTEND_ROUTES.public.homePatient}
            backToTextKey="common:not_found.back_to_dashboard_patient"
            moduleName="patient"
          />
        }
      />
    </Routes>
    <CookieNotice />
    </>
  );
}
